import axios from 'axios'
import cookie from 'cookie'
import renameKeys from 'deep-rename-keys'
import { camelCase, get, snakeCase } from 'lodash'

const api = axios.create({
  timeout: 50000,
  headers: {
    'X-CSRF-Token': cookie.parse(document.cookie)['csrf_cookie'],
  },
})
api.interceptors.response.use(undefined, err => err.response)

if (process.env.VUE_APP_USE_MOCK) {
  require('./mock').default(api)
}

/**
 * API に POST します。
 *
 * @param {string} path APIのパス
 * @param {object} params リクエストパラメータ
 */
export async function POST(path, params = {}) {
  params = renameKeys(params, snakeCase)
  if (process.env.NODE_ENV !== 'test') console.log('%cPOST %c%s', 'color: green;', '', path, params)
  const res = await api.post(path, params)
  if (process.env.NODE_ENV !== 'test')
    if (res.status === 200) {
      console.log('%c%d %c%s', 'color: blue;', res.status, '', path, res.data)
    } else {
      console.error('%d %s', res.status, path, res.data)
    }
  return handleResponse(res)
}

function handleResponse({ status, code, data }) {
  if (!status && code !== 'ECONNABORTED') {
    return { status: 0, data: null, message: '' }
  }

  data = data ? renameKeys(data.data || data, camelCase) : null
  const message =
    status !== 200 || !data || data.status !== 1
      ? get(data, 'message') ||
        get(data, 'error.message') ||
        '処理中にエラーが発生しました。\n恐れ入りますがしばらくお時間をあけてページの再読込をおこなってください。'
      : ''

  return { status, data, message }
}
